var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationAddSkills(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#illustration-add-skills_svg__clip0_3693_28640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 200c55.228 0 100-44.772 100-100S155.228 0 100 0 0 44.772 0 100s44.772 100 100 100z",
    fill: "#E7EAFC"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-add-skills_svg__filter0_d_3693_28640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M190 30c0-11.046-8.954-20-20-20s-20 8.954-20 20 8.954 20 20 20 20-8.954 20-20z",
    fill: "#FF7181"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M172.578 29.5l3.906 3.945a1.16 1.16 0 010 1.72l-.859.858a1.16 1.16 0 01-1.719 0L170 32.117l-3.945 3.906a1.16 1.16 0 01-1.719 0l-.859-.859a1.16 1.16 0 010-1.719l3.906-3.945-3.906-3.906a1.16 1.16 0 010-1.719l.859-.86a1.16 1.16 0 011.719 0L170 26.923l3.906-3.906a1.16 1.16 0 011.719 0l.859.859a1.16 1.16 0 010 1.719l-3.906 3.906z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-add-skills_svg__filter1_d_3693_28640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M155.003 123.995c8.283 0 14.998-6.715 14.998-14.998s-6.715-14.998-14.998-14.998-14.998 6.715-14.998 14.998 6.715 14.998 14.998 14.998z",
    fill: "#0D2976"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.62 90.392a3.09 3.09 0 01-2.477-1.25 3.066 3.066 0 01-.541-2.277c.063-.397.205-.777.416-1.119a3.04 3.04 0 01.812-.874 3.139 3.139 0 014.221.59c.024.024.047.049.047.074a3.052 3.052 0 01-2.478 4.857v-.001zM136.675 82.247a3.036 3.036 0 01-2.182-.908 3.125 3.125 0 01-.652-3.358c.156-.371.386-.707.675-.987a3.136 3.136 0 014.344.026 3.058 3.058 0 01-.026 4.319 3.032 3.032 0 01-2.16.908h.001zM128.577 75.227a3.128 3.128 0 01-1.84-.613 3.06 3.06 0 01-1.203-2.019 3.055 3.055 0 01.59-2.275 3.174 3.174 0 014.3-.637 3.082 3.082 0 01.612 4.294 3.05 3.05 0 01-2.454 1.25h-.005zM119.521 69.462a2.966 2.966 0 01-1.447-.369 3.043 3.043 0 01-1.493-1.812 3.031 3.031 0 01.243-2.335 3.115 3.115 0 014.148-1.25 3.07 3.07 0 011.521 3.448 3.07 3.07 0 01-2.972 2.318zM109.732 65.068a3.091 3.091 0 01-1.056-.173 3.124 3.124 0 01-1.716-1.6 3.014 3.014 0 01-.1-2.356 3.11 3.11 0 013.95-1.814 2.987 2.987 0 011.718 1.57 3.073 3.073 0 01-2.8 4.369l.004.004zM57.068 64.208a3.039 3.039 0 01-2.9-2.085 3.046 3.046 0 011.914-3.877 3.121 3.121 0 013.9 1.914 3.136 3.136 0 01-1.938 3.9 3.301 3.301 0 01-.981.146l.005.002zM99.451 62.073c-.223 0-.445-.023-.662-.072a3.064 3.064 0 011.3-5.988 2.975 2.975 0 011.939 1.349 3.046 3.046 0 01.417 2.308 3.088 3.088 0 01-2.993 2.4l-.001.003zM67.447 61.51a3.07 3.07 0 01-2.528-4.81 2.988 2.988 0 011.963-1.277c.184-.05.373-.074.563-.072a3.08 3.08 0 01.566 6.108 4.02 4.02 0 01-.566.051h.002zM88.821 60.456h-.269a3.057 3.057 0 01-2.064-1.081 3.001 3.001 0 01-.711-2.233 3.09 3.09 0 013.044-2.82c.025 0 .247.025.27.025a3.06 3.06 0 01-.27 6.109zM78.098 60.258a3.057 3.057 0 01-2.266-5.127 3.092 3.092 0 012.12-1.008h.025a3.074 3.074 0 012.405 5.128c-.553.6-1.32.962-2.135 1.006h-.149v.001z",
    fill: "#0D2976"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#illustration-add-skills_svg__filter2_d_3693_28640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.004 95.996l-8 44h-23l-8-44h-8l10 52h35l10-52h-8z",
    fill: "#0D2976"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "illustration-add-skills_svg__filter0_d_3693_28640",
    x: 144,
    y: 7,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0509804 0 0 0 0 0.160784 0 0 0 0 0.462745 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3693_28640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3693_28640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-add-skills_svg__filter1_d_3693_28640",
    x: 127.005,
    y: 90.999,
    width: 55.996,
    height: 55.996,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.12549 0 0 0 0 0.223529 0 0 0 0 0.819608 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3693_28640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3693_28640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "illustration-add-skills_svg__filter2_d_3693_28640",
    x: 64.004,
    y: 92.996,
    width: 67,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3693_28640"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3693_28640",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "illustration-add-skills_svg__clip0_3693_28640"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v200H0z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationAddSkills);
export default ForwardRef;